var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelephone = function SvgTelephone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "telephone_svg__\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".telephone_svg__st0{fill:none;stroke:#000;stroke-width:1.5;stroke-miterlimit:10}")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "telephone_svg__\\u0421\\u043B\\u043E\\u0439_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "telephone_svg__XMLID_1_",
    className: "telephone_svg__st0",
    d: "M13.8 18s3.5 3.4 4.9 3.7l2.9-2.9s1.1-1.1 2.4 0l4.8 4.8s.8 1.4-.1 2.3l-2.3 2.3s-4.1 2.6-10.7-1.6c0 0-3.1-1.6-6-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "telephone_svg__XMLID_4_",
    className: "telephone_svg__st0",
    d: "M14 18.3s-3.4-3.5-3.7-4.9l2.9-2.9s1.1-1.1 0-2.4L8.4 3.3s-1.4-.8-2.3.1L3.8 5.7S1.2 9.8 5.4 16.4c0 0 1.6 3.1 4.6 6"
  }))))));
};
export default SvgTelephone;